var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.image,"description":_vm.description}})}
var staticRenderFns = []

export { render, staticRenderFns }